<div class="matomo__overlay"></div>

<div class="matomo-banner" data-testid="matomo-banner">
    <mat-card class="riege-card matomo-banner__inner">
        <mat-card-content>
            <h2 i18n="@@consent-headline">Cookie settings</h2>
            <p
                ><span i18n="@@consent-description">We use cookies to improve and to analyse out website for you.</span
                ><br />
                <a href="{{ linkPrivacy }}" target="_blank" class="matomo-banner__link" i18n="@@consent-link-privacy"
                    >Please see our privacy policy</a
                >.</p
            >

            <mat-divider class="margin-bottom--base"></mat-divider>

            <div class="matomo-banner__option-setting">
                <h3 i18n="@@consent-functional-headline">Functional</h3>
                <small i18n="@@consent-functional-hint">Always active</small>
                <mat-slide-toggle checked disabled aria-label="Functional Cookies"></mat-slide-toggle>
            </div>
            <p i18n="@@consent-functional-description"
                >Functional cookies allow us to save your settings and language choice, so that you can see this website
                in the correct language next time.</p
            >

            <div class="matomo-banner__option-setting">
                <h3 i18n="@@consent-performance-headline">Statistic & Performance</h3>
                <mat-slide-toggle
                    [aria-label]="checked ? disallowPerformanceTracking : allowPerformanceTracking"
                    (toggleChange)="checked = !checked"
                    [checked]="checked"></mat-slide-toggle>
            </div>
            <p i18n="@@consent-performance-description"
                >These cookies enable us to count visits and traffic sources, so that we can measure and improve the
                performance of our website.</p
            >
        </mat-card-content>

        <mat-dialog-actions align="end">
            <button class="riege-button" mat-stroked-button (click)="checked = !checked">{{
                checked ? rejectAll : acceptAll
            }}</button>
            <button
                autofocus
                class="riege-button"
                mat-flat-button
                (click)="handleConsent()"
                data-testid="matomo-save"
                i18n="@@button-label-accept-selected"
                >Save selection</button
            >
        </mat-dialog-actions>
    </mat-card>
</div>
